<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
  html, body, #app {
    width: 100%;
    height: 100%;
  }
  .el-tree-node__expand-icon {
    font-size: 16px;
    color: #666;
    font-weight: bold;
  }
  .el-icon-caret-right:before {
    content: '\e6df';
  }
</style>



// WEBPACK FOOTER //
// src/App.vue